// @flow
import React from 'react';
import { connect } from 'react-redux';

import * as actions from '../../actions/time';

type ClockPropTypes = {
  interval: number,
  onTick: Function
};

class Clock extends React.Component<ClockPropTypes> {
  componentWillMount() {
    const { interval = 50000, onTick } = this.props;
    this._interval = setInterval(onTick, interval);
    onTick();
  }

  componentWillUnmount() {
    return this._interval && clearInterval(this._interval);
  }

  _interval: IntervalID;

  render = () => null;
}

export default connect(
  undefined,
  dispatch => ({
    onTick() {
      dispatch(actions.updateTime(Date.now()));
    },
  }),
)(Clock);



// WEBPACK FOOTER //
// ./src/scripts/components/Clock/index.jsx